import { Component, Input } from '@angular/core';

import { SmPinDirective } from '../directives/sm-pin.directive';

@Component({
	selector: 'sm-toolbar-buttons',
	template: require('./sm-toolbar-buttons.component.html'),
	exportAs: 'smToolbarButtons'
})
export class SmToolbarButtons {
	constructor(public pin: SmPinDirective) { }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-toolbar-buttons.component.ts